import { scrollAnime } from "./components/scrollAnime";
import { humbergerMenuButton } from "./components/humbergerMenuButton";
import { accordion } from "./components/accordion";
import { tab } from "./components/tab";
import { slider } from "./components/slider";
import { inputError } from "./components/inputError";
import { megaMenu } from "./components/megaMenu";
import { modal } from "./components/modal";
import { pageTop } from "./components/pageTop";
// import { scrollify } from "./jquery.scrollify";
// import { onepage_scroll } from "./jquery.onepage-scroll.min";



$(document).ready(function () {

  (() => {
    /*
    アニメーション用関数
    */
    //アニメーション用クラスを定義
    const animeEl = ".u-anime";
    //スクロール時に付与されるクラス定義
    const addAnimeClass = "fadeIn";
    scrollAnime(animeEl, addAnimeClass);

  })();

  (() => {
    /*
    ハンバーガーメニュー用関数
    */
    //ハンバーガーメニューボタンクラス定義
    const buttonEl = ".navOpen";
    //ハンバーガーメニュークラス定義
    const menuEl = ".l-nav";
    const closeEl = ".navClose";
    humbergerMenuButton(buttonEl, menuEl, closeEl);
  })();

  (() => {
    /*
    スライダー用関数
    */
    const sliderEl = ".swiper";
    slider(sliderEl);
  })();

  (() => {
    /*
    アコーディオン用関数
    */
    //アコーディオンラッパークラス定義
    const accordionEl = ".accordion";
    //アコーディオンボタンクラス定義
    const accordionButtonEl = ".accordionButton";
    //アコーディオンアイテムクラス定義
    const accordionItemEl = ".accordionItem";
    accordion(accordionEl, accordionButtonEl, accordionItemEl);
  })();

  (() => {
    /*
    アコーディオン用関数
    */
    const modalEl = ".modal";
    const modalContainerEl = ".modalContainer";
    const modalBodyEl = ".modalBody";
    const modalButtonEl = ".modalButton";
    const modalCloseEl = ".modalClose";
    modal(modalEl, modalContainerEl, modalBodyEl, modalButtonEl, modalCloseEl);
  })();

  (() => {
    /*
    タブ用関数
    */
    //タブボタンラッパークラス定義
    const tabButtonEl = ".tabButton";
    //タブコンテンツラッパークラス定義
    const tabContentsEl = ".tabContent";
    tab(tabButtonEl, tabContentsEl);
  })();

  (() => {
    /*
    メガメニュー用関数
    */
    //メガメニューラッパークラス定義
    const megaMenuEl = "#megaMenu";
    //メガメニューナビアイテムクラス定義
    const megaMenuItemEl = ".megaMenuItem";
    //メガメニューコンテンツクラス定義
    const megaMenuContents = ".megaMenuContents";
    megaMenu(megaMenuEl, megaMenuItemEl, megaMenuContents);
  })();

  (() => {
    /*
    フォームバリデーション用関数
    */
    //フォームラッパークラス定義
    const formEl = ".p-form";
    //エラー表示用クラス定義
    const addErrorClass = "c-error";
    //WPなどでフォームから出力されるエラークラスを定義
    const errorEl = "error";
    inputError(formEl, addErrorClass, errorEl);
  })();

  (() => {
    /*
    ページトップボタン用関数
    */
    //ボタンクラス定義
    const pageTopButtonEl = "#pageTop";
    //初期状態を定義
    const hide = true;
    pageTop(pageTopButtonEl, hide);
  })();


  // $(".l-content--about__slides").onepage_scroll({
  //   sectionContainer: "div",
  //   loop: false,
  // });


  // var windowWidth = $(window).width();
  // var windowSm = 992;
  // if (windowWidth <= windowSm) {
  //     //横幅640px以下のとき（つまりスマホ時）に行う処理を書く
  // } else {
  //     //横幅640px超のとき（タブレット、PC）に行う処理を書く
  //   $.scrollify({
  //     section : ".oneScroll",
  //     // interstitialSection : "#header,#footer",//ヘッダーフッターを認識し、1ページスクロールさせず表示されるように設定
  //
  //     sectionName : "section-name",
  //     interstitialSection : "",
  //     easing: "easeOutExpo",
  //     scrollSpeed: 1100,
  //     offset : 0,
  //     scrollbars: true,
  //     standardScrollElements: ".normalScroll",
  //     setHeights: false,
  //     overflowScroll: true,
  //     updateHash: true,
  //     touchScroll:true,
  //     before:function() {},
  //     after:function() {},
  //     afterResize:function() {},
  //     afterRender:function() {}
  //   });
  // }

  // $.scrollify.disable();
  //
  // var scroll;
  // var winH = $(window).height();
  // var objTop = $('.l-content--about__slides').offset().top;
  // $(window).on('scroll', function(){
  //   scroll = $(window).scrollTop();
  //   if(scroll >= objTop - winH/2){
  //     $.scrollify.enable();
  //   } else {
  //     $.scrollify.disable();
  //   }
  // });
  //
  // var scroll;
  // var winH = $(window).height();
  // var objH = $('.l-content--about__slides').outerHeight();
  // var objTop = $('.l-content--about__slides').offset().top;
  // var objBottom = objTop + objH;
  // $(window).on('scroll', function(){
  //   scroll = $(window).scrollTop();
  //   if(scroll >= objBottom - winH){
  //     $.scrollify.enable();
  //     $.scrollify.instantMove("#start");
  //   } else {
  //     $.scrollify.disable();
  //   }
  // });

});
